module.exports = __webpack_public_path__ + "src/img/stylemarks/laptop-4.6bd05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/laptop-4.jpg
// module id = 119
// module chunks = 0